@if (showSpinner) {
<app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isLoanApprovedPermission('isloanView')) {
  <div class="container-fluid mb-4 ">
    <div class="leaveManagmentParent">
      <div class="leftLM" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <p class="headingleavemanagement">Loan Reports</p>
      </div>
      <div class="rightLM">
        <!-- <button type="button" class="btnLeaveReport" [routerLink]="'/employee-payroll-managment'">Back to Main</button> -->
      </div>
    </div>
    <!-- 2nd row -->
    <div class="parentFilter mb-3" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="leftsideFilter">
        <p class="headingFilter">Filter</p>
      </div>
      <div class="rightsideFilter">
        <div class="txtboxName"> <input type="text" placeholder="Search by Name" [(ngModel)]="nameFilter" /></div>
        <div class="btnApply"> <button type="button" (click)="getloanFilter()">Apply</button></div>
      </div>
    </div>
    <!-- 3rd row -->
    <div class="tablewidth mt-0">
      <table class="bg-white" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
        <tr id="tableHead" class="tableHead">
          <th class="namefieldHead">Name</th>
          <th>Loan Amount</th>
          <th>Months</th>
          <th>Loan Installment PM</th>
          <th>Apply Date</th>
        </tr>
        @for (data of loans; track data) {
        <tr class="tableData"
          [ngClass]="{'green-border': data.status === 'approved', 'red-border': data.status === 'rejected'}">
          <td class="colorName">{{data.user.first_name}}</td>
          <td>{{data.loan_amount}}</td>
          <td>{{data.loan_duration}}
            @if (data.status === 'approved') {
            <i class="fa fa-info-circle" style="font-size:18px;color:rgb(218, 218, 218);cursor: pointer;"
              data-toggle="modal" data-target="#infoModalCenter" (click)="setModalData(data)"></i>
            }
          </td>
          <td>{{data.installment}}</td>
          <td>{{data.loan_date}}</td>
        </tr>
        <tr class="tableData1"
          [ngClass]="{'green-border': data.status === 'approved', 'red-border': data.status === 'rejected'}">
          <td class="colorName">Loan Purpose</td>
          <td colspan="4">{{data.loan_reason}}</td>
        </tr>
        <tr class="tableData1"
          [ngClass]="{'green-border': data.status === 'approved', 'red-border': data.status === 'rejected'}">
          <td class="colorName">Document</td>
          <td class="loan-file-image" colspan="4">
            @if (data.loan_file) {
            <img [src]="data.loan_file" alt="Image Description" (click)="selectimage(data.loan_file)"
              data-toggle="modal" data-target="#imgModal">
            }
            @if (!data.loan_file) {
            <p class="text-danger p-0 m-0">No File Attached</p>
            }
          </td>
        </tr>
        <tr class="tableDataBorder" [ngClass]="{'green-border': data.status === 'approved', 'red-border': data.status === 'rejected','dark-border': selectedMode === 'dark'
        }">
          @if (data.status === 'approved') {
          <td class="colorName circle-td">Quick View</td>
          }
          @if (data.status === 'approved') {
          <td colspan="2" class="row circle-td">
            @for (circle of getCircleArray(data.loan_duration); track circle; let i = $index) {
            <div>
              <div class="circle-view" [class.green]="i < data.paid_intallement_count">
                @if (i < data.paid_intallement_count) { <i class="fa fa-check-circle"
                  style="font-size:24px; color:#4FDDAD;background-color: white;"
                  [ngClass]="{ 'dark-backround': selectedMode === 'dark' }"></i>
                  }
                  @if (i === data.paid_intallement_count) {
                  <span class="circle"></span>
                  }
              </div>
            </div>
            }
          </td>
          }
          <td colspan="6">
            <div class="actionBtn pb-3 pt-3">
              @if ( isLoanApprovedPermission('isReject') && data.status === 'pending') {
              <button class="btn rejectbtn" (click)="approveLoan(data.id, 'rejected')"
                [ngClass]="{ 'bg-light mr-2': selectedMode === 'dark' }">
                Reject
              </button>
              }
              @if (data.status === 'rejected') {
              <span id="rejectBy">Rejected by:</span>
              }
              @if (data.status === 'rejected') {
              <div class="btn rejectbtn">
                <div class="rejectInner p-0">
                  <div class="adminName"><b>{{data.updated_by_user}}</b></div>
                  <div class="updatedAt" [ngClass]="{ 'updatedAt-dark': selectedMode === 'dark' }">{{data.updated_at |
                    date:'yyyy-MM-dd'}}</div>
                </div>
              </div>
              }
              @if (data.status === 'rejected') {
              <button class="btn rejectebtn" type="button">
                Rejected
              </button>
              }
              @if (isLoanApprovedPermission('isAccept') && data.status === 'pending') {
              <div class="btn btn-primary approvebtn" (click)="approveLoan(data.id, 'approved') ">
                Approve
              </div>
              }
              @if (data.status === 'approved') {
              <span id="approveBy" style="color: #4FDDAD;">Accepted by:</span>
              }
              @if (data.status === 'approved') {
              <div class="btn approvedBy">
                <div class="approveInner p-0">
                  <div class="adminName"><b>{{data.updated_by_user}} </b></div>
                  <div class="updatedAt" [ngClass]="{ 'updatedAt-dark': selectedMode === 'dark' }">{{data.updated_at |
                    date:'yyyy-MM-dd'}}</div>
                </div>
              </div>
              }
              @if (data.status === 'approved') {
              <button class="btn btn-primary approvebtn border-0 mr-1" style="background-color: #4FDDAD;">
                Approved
              </button>
              }
              @if (data.status === 'completed') {
              <button class="btn btn-primary approvebtn border-0 mr-1" style="background-color: #4FDDAD;">
                Completed
              </button>
              }
            </div>
          </td>
        </tr>
        }
      </table>
    </div>
    <div class="modal fade" id="imgModal" tabindex="-1" role="dialog" aria-labelledby="dimgModalModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered imgModal" role="document">
        <div class="modal-content backmodal">
          <div class="modal-header image-title">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" style="color:white;">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center modal-image">
            <img [src]="selectimg" alt="Missing Document">
          </div>
          <!-- <div class="modal-footer image-footer">
            <button (click)="downloadImage()" class="btn btn-primary">Download</button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->
    <!-- Modal -->
    <div class="modal fade" id="infoModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="modal-body ">
            <div class="col-12 row p-0 m-0">
              <div class="col-12 heading-modal text-center pt-2 pb-2">
                <h5 class="m-0">Loan Detail</h5>
              </div>
              <div class="col-4 border data-head" [ngClass]="{ 'dark-backround1': selectedMode === 'dark' }">Total
                Amount</div>
              <div class="col-8 border data">Rs: {{(modalData?.loan_amount ?? 0)}} /- </div>
              <div class="col-4 border data-head" [ngClass]="{ 'dark-backround1': selectedMode === 'dark' }">Remaining
                Installment</div>
              <div class="col-8 border data">{{((modalData?.loan_duration ?? 0) - (modalData?.paid_intallement_count ??
                0)) }}
                Months
              </div>
              <div class="col-4 border data-head" [ngClass]="{ 'dark-backround1': selectedMode === 'dark' }">Remaining
                Amount</div>
              <div class="col-8 border data">Rs: {{ (modalData?.loan_amount ?? 0) - ((modalData?.paid_intallement_count
                ??
                0) *
                (modalData?.installment ?? 0) ) }} /- </div>
              <div class="col-4 border data-head" [ngClass]="{ 'dark-backround1': selectedMode === 'dark' }">Total Paid
                Amount</div>
              <div class="col-8 border data">Rs: {{(modalData?.paid_intallement_count ?? 0) * (modalData?.installment ??
                0) }} /-
              </div>
              <div class="col-4 border data-head" [ngClass]="{ 'dark-backround1': selectedMode === 'dark' }">Total
                Installments Done</div>
              <div class="col-8 border data">{{(modalData?.paid_intallement_count ?? 0)}} Months</div>
            </div>
          </div>
          <div class="modal-footer pt-0">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</main>